import {AnimationBaseController, IAnimationControllerConfiguration, Inject} from "@denishussar/html5-game-engine";
import {DinnerLogic} from "../Logic/DinnerLogic";
import {FoodModel, FoodStateEnum} from "../Models/FoodModel";

export interface IFoodControllerOptions {
    name: string;
}

export class FoodController extends AnimationBaseController {

    $model: FoodModel;

    public constructor(@Inject private _options: IFoodControllerOptions,
                       @Inject private _gameLogic: DinnerLogic) {
        super(_options.name);
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return {
            childControllers: {},
            modelWatch: {
                "state": (newValue: FoodStateEnum, oldValue: FoodStateEnum) => {

                    this.gotoAndStop(`${FoodStateEnum[this.$model.state]}`);

                    this.display.interactive = newValue !== FoodStateEnum.empty;

                    //!this.display.interactive && this.name === "coffee" && this.gotoAndStopByQuery("steam");

                }
            },
            onPointerDown: e => {
                this._gameLogic.eat(this.$model);
            },
        };
    }

    protected onInitialize(): void {

        //this.animationControlByParent = this.name !== "coffee";
        //this.name === "coffee" && this.gotoAndPlayByQuery("steam", 0, true);
    }

    protected onAnimationEvent(name: string, ...args): void {

    }
}
